module.exports = __webpack_public_path__ + "static/media/CashMap.043d3b63.png";